import React from 'react';

import { Button } from 'react-bootstrap';
import { useIntl } from 'react-intl';

import { WarningIcon } from 'assets/icons';

interface HeightWeightBannerProps {
  onAdd: () => void;
}

export const HeightWeightBanner = ({ onAdd }: HeightWeightBannerProps) => {
  const intl = useIntl();

  return (
    <div className="height-weight-banner" role="alert" data-test="height-weight-banner">
      <WarningIcon className="icon flex-shrink-0" />
      <span>
        {intl.formatMessage({ id: 'heightWeightNeededKey' })}{' '}
        <Button variant="link" onClick={onAdd} data-test="height-weight-banner-add">
          {intl.formatMessage({ id: 'addHeightWeightKey' })}
        </Button>
      </span>
    </div>
  );
};
